export default "__VITE_ASSET__56e8bf6b__"